import { useState } from "react";
import styled, { createGlobalStyle } from "styled-components";
import TimeReport from "../../pages/TimeReport";



export default function TimeLog({fetchMatter}) {
  return (
    <>
      <div style={{ marginTop: '1.5rem' }}></div>
      <TimeReport fetchMatter={fetchMatter}/>
    </>
  );
}
